'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _React = require('React');

var _React2 = _interopRequireDefault(_React);

var _I18nReact = require('I18n.React.FormattedHTMLMessage');

var _I18nReact2 = _interopRequireDefault(_I18nReact);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _React2.default.createClass({
  displayName: 'SkeletonDurationPicker',
  render: function render() {
    return _React2.default.createElement(
      'div',
      { className: 'duration-picker width-100' },
      _React2.default.createElement(
        'h5',
        { className: 'skeleton-text' },
        _React2.default.createElement(_I18nReact2.default, { message: 'prebook.durationPicker.header' })
      ),
      _React2.default.createElement('div', { className: 'skeleton m-top-8 m-bottom-12' })
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/components/schedule/duration/SkeletonDurationPicker.js
// module id = 437
// module chunks = 0